module.exports = __webpack_public_path__ + "static/shawna-power-down-cutout-97e99818dadccc3b83c748983939cc1e.png";